import React, { useState, useEffect } from 'react';

const ManageAccessCodes = () => {
  const [accessCodes, setAccessCodes] = useState([]);
  const [newCode, setNewCode] = useState({
    email: '',
    maxUses: 1,
    expiresInDays: 30,
    description: ''
  });
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchAccessCodes();
  }, []);

  const fetchAccessCodes = async () => {
    try {
      console.log('Fetching access codes...');
      const response = await fetch('https://schoolofservice.co.za/backend/get_access_codes.php');
      console.log('Fetch response status:', response.status);
      
      const data = await response.json();
      console.log('Fetch response data:', data);
      
      if (data.status === 'success') {
        setAccessCodes(data.accessCodes);
      } else {
        setMessage('Failed to fetch access codes: ' + data.message);
      }
    } catch (error) {
      console.error('Fetch access codes error:', error);
      setMessage('Error fetching access codes: ' + error.message);
    }
  };

  const generateAccessCode = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      console.log('Sending request to generate access code...');
      console.log('Payload:', newCode);
      
      const response = await fetch('https://schoolofservice.co.za/backend/generate_access_code.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newCode),
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      const data = await response.json();
      console.log('Response data:', data);
      
      if (data.status === 'success') {
        setMessage(`Access code generated successfully: ${data.code} for ${data.email}`);
        setNewCode({
          email: '',
          maxUses: 1,
          expiresInDays: 30,
          description: ''
        });
        fetchAccessCodes(); // Refresh the list
      } else {
        setMessage('Failed to generate access code: ' + data.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setMessage('Error generating access code: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badgeClasses = {
      'Active': 'badge bg-success',
      'Expired': 'badge bg-warning',
      'Used Up': 'badge bg-danger',
      'Inactive': 'badge bg-secondary'
    };
    
    return <span className={badgeClasses[status] || 'badge bg-secondary'}>{status}</span>;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h4>Generate New Access Code</h4>
            </div>
            <div className="card-body">
              <form onSubmit={generateAccessCode}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email Address *</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={newCode.email}
                    onChange={(e) => setNewCode({...newCode, email: e.target.value})}
                    placeholder="Enter recipient's email address"
                    required
                  />
                  <div className="form-text">The email address of the person who will receive this access code</div>
                </div>
                
                <div className="mb-3">
                  <label htmlFor="maxUses" className="form-label">Maximum Uses</label>
                  <input
                    type="number"
                    className="form-control"
                    id="maxUses"
                    value={newCode.maxUses}
                    onChange={(e) => setNewCode({...newCode, maxUses: parseInt(e.target.value)})}
                    min="1"
                    max="100"
                    required
                  />
                </div>
                
                <div className="mb-3">
                  <label htmlFor="expiresInDays" className="form-label">Expires In (Days)</label>
                  <input
                    type="number"
                    className="form-control"
                    id="expiresInDays"
                    value={newCode.expiresInDays}
                    onChange={(e) => setNewCode({...newCode, expiresInDays: parseInt(e.target.value)})}
                    min="1"
                    max="365"
                    required
                  />
                </div>
                
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">Description (Optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    id="description"
                    value={newCode.description}
                    onChange={(e) => setNewCode({...newCode, description: e.target.value})}
                    placeholder="e.g., For workshop participants"
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? 'Generating...' : 'Generate Access Code'}
                </button>
              </form>
              
              {message && (
                <div className={`alert ${message.includes('successfully') ? 'alert-success' : 'alert-danger'} mt-3`}>
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h4>Access Codes Overview</h4>
            </div>
            <div className="card-body">
              <div className="row text-center">
                <div className="col-4">
                  <h5 className="text-success">{accessCodes.filter(code => code.status === 'Active').length}</h5>
                  <small>Active</small>
                </div>
                <div className="col-4">
                  <h5 className="text-warning">{accessCodes.filter(code => code.status === 'Expired').length}</h5>
                  <small>Expired</small>
                </div>
                <div className="col-4">
                  <h5 className="text-danger">{accessCodes.filter(code => code.status === 'Used Up').length}</h5>
                  <small>Used Up</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4>All Access Codes</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Email</th>
                      <th>Status</th>
                      <th>Used</th>
                      <th>Max Uses</th>
                      <th>Created</th>
                      <th>Expires</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accessCodes.map((code) => (
                      <tr key={code.id}>
                        <td>
                          <code className="fs-6">{code.code}</code>
                        </td>
                        <td>
                          <span className="text-primary">{code.email || 'N/A'}</span>
                        </td>
                        <td>{getStatusBadge(code.status)}</td>
                        <td>{code.used_count}</td>
                        <td>{code.max_uses}</td>
                        <td>{formatDate(code.created_at)}</td>
                        <td>
                          {code.expires_at ? formatDate(code.expires_at) : 'Never'}
                        </td>
                        <td>{code.description || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {accessCodes.length === 0 && (
                <p className="text-center text-muted">No access codes generated yet.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAccessCodes; 